import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './DockAppointments.frontend.types'

@Injectable({ providedIn: 'root' })
export class DockAppointments_get_formatted_dock_appointmentService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { dock_appointments: { id: number, optimal_inputs?: { scheduled_location_name?: string, assigned_location_name?: string, status_id?: number, lookup?: string, scheduled_arrival?: string } }[] }): Promise<{ dock_appointments?: { id: number, formatted_value: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.dock_appointments)) {
      missingRequiredInParams.push('\'dock_appointments\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/functions/get_formatted_dock_appointment`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

